module.exports = __webpack_public_path__ + "static/img/p10.dcb6bde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p10.png
// module id = vu9n
// module chunks = 15